import { Component, HostBinding } from '@angular/core';
import { Location } from '@angular/common';
import { LayoutService } from './layout.service';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { NavigationService } from './navigation.service';
import { join, map } from 'lodash';
import 'whatwg-fetch'
import 'hammerjs';
import 'Modernizr';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  @HostBinding('style.overflow') get overflow() { return this.LayoutService.overflow; };
  @HostBinding('style.height') get height() { return this.LayoutService.overflow === 'hidden' ? '100%' : null; };
  landscapeEnabled: boolean;
  navigationSubscription: Subscription;

  constructor(
    public LayoutService: LayoutService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private location: Location,
    private NavigationService: NavigationService
  ) {


    /**
    Going from home to project
    Going from index to project
    Going from category to project

    **/
    
    this.navigationSubscription = router.events
      .filter(event => event instanceof NavigationEnd)
      .map(() => router.routerState.root)
      .map((route) => {
        while (route.firstChild) route = route.firstChild;
        return route;
      })
      .filter((route) => route.outlet === 'primary')
      .subscribe((root) => {
        let data = root.snapshot.data;
        this.NavigationService.setTitleAndMetaDescription(data['api'], data['title']);
        let slugs = root.parent.snapshot.url;
        this.LayoutService.showSplashscreen = slugs.length === 0 && !this.LayoutService.haveShownSplashscreen ? null : false;
        this.NavigationService.slugs = {
          parent: slugs.length > 0 ? slugs[0].toString() : '',
          child: slugs.length > 1 ? slugs[1].toString() : ''
        };
        // Going from home page to project
        if (slugs.length === 0) {
          this.NavigationService.pageType = 'home';
        } else if (slugs[0].path === 'project-index') {
          this.NavigationService.pageType = 'index';
        }
      });
  }

  getUrlFromSegments(segments) {
    return join(map(segments, (seg) => seg.toString()), '/')
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.navigationSubscription.unsubscribe();
  }

  isLandscapeEnabled() {
    return this.LayoutService.isLandscapeEnabled;
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts